import { assignInlineVars } from "@vanilla-extract/dynamic";
import React from "react";
import { BaseSpacingValue, vars } from "web/react/emo/theme.css";
import { RadioButtonWithLabel } from "./radio-button-with-label";
import { RadioCard } from "./radio-card";
import * as styles from "./radio-card-group.css";

interface RadioCardGroupProps {
    stacked?: boolean;
    gap?: BaseSpacingValue;
    children: React.ReactNode;
}

function RadioCardGroup({
    stacked = true,
    gap = "sm",
    children,
}: RadioCardGroupProps): React.ReactElement {
    const gapVar = vars.spacing[gap];

    return (
        <fieldset
            className={styles.container[stacked ? "stacked" : "spaced"]}
            style={assignInlineVars({
                [styles.gap]: gapVar,
            })}
        >
            {children}
        </fieldset>
    );
}

RadioCardGroup.Card = RadioCard;
RadioCardGroup.Button = RadioButtonWithLabel;

export { RadioCardGroup };
